<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="truck-checkout"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Truck check out {{ Truckattendance.truck_no }}</small
                >
              </legend>
              <form @submit.prevent="checkOut()">
                <div class="row">
                  <input
                    type="hidden"
                    class="truckattendance_id"
                    :value="Truckattendance.id"
                  />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Check out</label>
                      <input
                        type="datetime-local"
                        class="form-control time_out"
                        placeholder="occupation name"
                        required
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Reasons for Check out</label>
                      <select
                        name="description"
                        class="form-control description"
                        required
                      >
                        <option>select reason for check out</option>
                        <option value="LOADING AT CCF">LOADING AT CCF</option>
                        <option value="LOADING AT PORT(KPA)">LOADING AT PORT(KPA)</option>
                        <option value="LOADING AT AUTO-PORT">LOADING AT AUTO-PORT</option>
                        <option value="LOADING AT FFK(CONSOL BASE)">LOADING AT FFK(CONSOL BASE)</option>
                        <option value="OUT OF GARAGE">OUT OF GARAGE</option>
                      </select>
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat updatingTruckAttendance"
                >
                  <i class="fa fa-plus"></i> Truck Check in
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat updatingTruckAttendanceLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      id="attendanceModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Truck attendance</small
                >
              </legend>
              <form @submit.prevent="viewTruckattendance()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingAttendance"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingAttendanceLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >manage transporters trucks</small
        >
      </legend>
      <button
        type="button"
        class="btn btn-success btn-roundec"
        data-toggle="modal"
        data-target="#attendanceModal"
      >
        <i class="fa fa-file-pdf-o"></i> General attendance
      </button>
      <p></p>
      <p></p>
      <div></div>
      <div>
        <div class="truckattendancesLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i
          >loading trucks attendance...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemTruckattendances"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Check_Out'">
              <span v-if="props.row.checked_out === 0">
                <button
                  class="btn btn-info btn-sm btn-rounded"
                  @click="viewCheckout(props.row.id)"
                >
                  <i class="fa fa-clock-o"></i> Check out
                </button>
              </span>
              <span v-else-if="props.row.checked_out === 1">
                <button class="btn btn-success btn-sm btn-rounded">
                  <i class="fa fa-clock-o"></i> Check out
                </button>
              </span>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
  <script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Time in",
          field: "time_in",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Time_out",
          field: "time_out",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Check_Out",
          field: "Check_Out",
          width: "122px",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadTruckattendances();
  },
  computed: {
    ...mapGetters(["systemTruckattendances", "Truckattendance"]),
  },
  methods: {
    ...mapActions([
      "loadTruckattendances",
      "viewCheckout",
      "loadTruck",
      "newJobcard",
      "checkOut",
      "viewTruckattendance",
    ]),
  },
};
</script>
  <style scoped>
.updatingTruckAttendanceLoader {
  display: none;
}
.creatingAttendanceLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucks/managetruckattendances.vue